/* eslint-disable no-unused-expressions */
import PermissionsService, {
  PERMISSION_AUTO_REPORT,
  PERMISSION_GDPR_USER_CHANGE_PROFILE,
  PERMISSION_ONLINE_MAP_TEMPLATES_ASSIGNMENT,
  PERMISSION_ONLINE_MAP_TEMPLATES_ASSIGNMENT_DEFAULT,
} from '../../Services/PermissionsService';
import {
  TABLE_ALARM,
  TABLE_AUTO_REPORT,
  TABLE_CORRECTIONS,
  TABLE_REFUELING,
  TABLE_REFUELINGS_IMPORT_RECORDS,
} from '../../Services/TableService';
import { IAction } from './TableBody/TableRow';

export const getAllowedMultipleActions = (
  allActions: IAction[],
  tableName: string,
  ids: number[],
  selectedCustomersRows: number[],
  refuelingsImportRecords
) => {
  const allowedActions: any = [];
  allActions.forEach((item: any) => {
    switch (item.id) {
      case 'action_assign':
        if (
          PermissionsService.hasAccess(
            PERMISSION_ONLINE_MAP_TEMPLATES_ASSIGNMENT,
            ['update'],
            selectedCustomersRows
          )
        ) {
          allowedActions.push(item);
        }
        break;
      case 'action_assignDefault':
        if (
          PermissionsService.hasAccess(
            PERMISSION_ONLINE_MAP_TEMPLATES_ASSIGNMENT_DEFAULT,
            ['update'],
            selectedCustomersRows
          )
        ) {
          allowedActions.push(item);
        }
        break;
      case 'action_activate':
        if (tableName === TABLE_ALARM) {
          if (PermissionsService.hasAccess(TABLE_ALARM, ['update'], selectedCustomersRows)) {
            allowedActions.push(item);
          }
        } else if (tableName === TABLE_AUTO_REPORT) {
          if (
            PermissionsService.hasAccess(
              `${PERMISSION_AUTO_REPORT}01`,
              ['update'],
              selectedCustomersRows
            ) &&
            PermissionsService.hasAccess(
              `${PERMISSION_AUTO_REPORT}02`,
              ['update'],
              selectedCustomersRows
            ) &&
            PermissionsService.hasAccess(
              `${PERMISSION_AUTO_REPORT}03`,
              ['update'],
              selectedCustomersRows
            ) &&
            PermissionsService.hasAccess(
              `${PERMISSION_AUTO_REPORT}04`,
              ['update'],
              selectedCustomersRows
            ) &&
            PermissionsService.hasAccess(
              `${PERMISSION_AUTO_REPORT}05`,
              ['update'],
              selectedCustomersRows
            ) &&
            PermissionsService.hasAccess(
              `${PERMISSION_AUTO_REPORT}06`,
              ['update'],
              selectedCustomersRows
            )
          ) {
            allowedActions.push(item);
          }
        }
        break;
      case 'action_deactivate':
        if (tableName === TABLE_ALARM) {
          if (PermissionsService.hasAccess(TABLE_ALARM, ['update'], selectedCustomersRows)) {
            allowedActions.push(item);
          }
        } else if (tableName === TABLE_AUTO_REPORT) {
          if (
            PermissionsService.hasAccess(
              `${PERMISSION_AUTO_REPORT}01`,
              ['update'],
              selectedCustomersRows
            ) &&
            PermissionsService.hasAccess(
              `${PERMISSION_AUTO_REPORT}02`,
              ['update'],
              selectedCustomersRows
            ) &&
            PermissionsService.hasAccess(
              `${PERMISSION_AUTO_REPORT}03`,
              ['update'],
              selectedCustomersRows
            ) &&
            PermissionsService.hasAccess(
              `${PERMISSION_AUTO_REPORT}04`,
              ['update'],
              selectedCustomersRows
            ) &&
            PermissionsService.hasAccess(
              `${PERMISSION_AUTO_REPORT}05`,
              ['update'],
              selectedCustomersRows
            ) &&
            PermissionsService.hasAccess(
              `${PERMISSION_AUTO_REPORT}06`,
              ['update'],
              selectedCustomersRows
            )
          ) {
            allowedActions.push(item);
          }
        }
        break;
      case 'action_assign-profile':
        if (
          PermissionsService.hasAccess(
            PERMISSION_GDPR_USER_CHANGE_PROFILE,
            ['update'],
            selectedCustomersRows
          )
        ) {
          allowedActions.push(item);
        }
        break;
      case 'action_remove':
        if (tableName === TABLE_REFUELING) {
          if (PermissionsService.hasAccess(TABLE_REFUELING, ['delete'], selectedCustomersRows)) {
            allowedActions.push(item);
          }
        } else if (tableName === TABLE_CORRECTIONS) {
          if (PermissionsService.hasAccess(TABLE_CORRECTIONS, ['delete'], selectedCustomersRows)) {
            allowedActions.push(item);
          }
        } else if (tableName === TABLE_ALARM) {
          if (PermissionsService.hasAccess(TABLE_ALARM, ['delete'], selectedCustomersRows)) {
            allowedActions.push(item);
          }
        } else if (tableName === TABLE_REFUELINGS_IMPORT_RECORDS) {
          if (tableName === TABLE_REFUELINGS_IMPORT_RECORDS) {
            if (
              PermissionsService.hasAccess(
                TABLE_REFUELINGS_IMPORT_RECORDS,
                ['delete'],
                selectedCustomersRows
              )
            ) {
              let actionDataCount = 0;
              refuelingsImportRecords.map((record: any) => {
                ids.map((id: any) => {
                  if (record.id === id) {
                    record.actions.filter((actionItem: any) => {
                      actionItem.id === 'action_remove' ? (actionDataCount += 1) : actionDataCount;
                    });
                  }
                });
              });

              if (ids.length === actionDataCount) {
                allowedActions.push(item);
              } else if (allowedActions[item]) {
                delete allowedActions[item];
              }
            }
          }
        }
        break;
      case 'action_status_pending':
        if (tableName === TABLE_REFUELINGS_IMPORT_RECORDS) {
          if (
            PermissionsService.hasAccess(
              TABLE_REFUELINGS_IMPORT_RECORDS,
              ['update'],
              selectedCustomersRows
            )
          ) {
            let actionDataCount = 0;
            refuelingsImportRecords.map((record: any) => {
              ids.map((id: any) => {
                if (record.id === id) {
                  record.actions.filter((actionItem: any) => {
                    actionItem.id === 'action_status_pending'
                      ? (actionDataCount += 1)
                      : actionDataCount;
                  });
                }
              });
            });

            if (ids.length === actionDataCount) {
              allowedActions.push(item);
            } else if (allowedActions[item]) {
              delete allowedActions[item];
            }
          }
        }
        break;
      case 'action_status_ignore':
        if (tableName === TABLE_REFUELINGS_IMPORT_RECORDS) {
          if (
            PermissionsService.hasAccess(
              TABLE_REFUELINGS_IMPORT_RECORDS,
              ['update'],
              selectedCustomersRows
            )
          ) {
            let actionDataCount = 0;
            refuelingsImportRecords.map((record: any) => {
              ids.map((id: any) => {
                if (record.id === id) {
                  record.actions.filter((actionItem: any) => {
                    actionItem.id === 'action_status_ignore'
                      ? (actionDataCount += 1)
                      : actionDataCount;
                  });
                }
              });
            });

            if (ids.length === actionDataCount) {
              allowedActions.push(item);
            } else if (allowedActions[item]) {
              delete allowedActions[item];
            }
          }
        }
        break;

      default:
      // code block
    }
  });

  return allowedActions;
};
